<template>
  <div class="page-content">
    <div class="page_div pa_div_sum">
      <div>总订单数</div>
      <div>{{ totalOrders }}</div>
      <el-button type="primary" @click="jumpPage('请选择')">查看</el-button>
    </div>
    <div class="page_div backgrond_clear">
      <div class="page_z dzf_color">
        <div class="label_left_top">待支付订单</div>
        <div class="label_right_top">{{ unpaidOrder }}</div>
        <el-button type="primary" class="label_left_bottom" @click="jumpPage('待支付')">查看</el-button>
      </div>
      <div class="page_z yzf_color">
        <div class="label_left_top">已支付订单</div>
        <div class="label_right_top">{{ paidOrder }}</div>
        <el-button type="primary" class="label_left_bottom" @click="jumpPage('已支付')">查看</el-button>
      </div>
    </div>
    <div class="page_div backgrond_clear">
      <div class="page_z zfz_color">
        <div class="label_left_top">支付中订单</div>
        <div class="label_right_top">{{ orderPayment }}</div>
        <el-button type="primary" class="label_left_bottom" @click="jumpPage('支付中')">查看</el-button>
      </div>
      <div class="page_z gq_color">
        <div class="label_left_top">过期订单</div>
        <div class="label_right_top">{{ expiredOrder }}</div>
        <el-button type="primary" class="label_left_bottom" @click="jumpPage('已过期')">查看</el-button>
      </div>
    </div>
    <div class="page_div backgrond_clear">
      <div class="page_z sx_color">
        <div class="label_left_top">失效订单</div>
        <div class="label_right_top">{{ invalidOrder }}</div>
        <el-button type="primary" class="label_left_bottom" @click="jumpPage('已失效')">查看</el-button>
      </div>
      <div class="page_z tk_color">
        <div class="label_left_top">退款订单</div>
        <div class="label_right_top">{{ refundOrder }}</div>
        <el-button type="primary" class="label_left_bottom" @click="jumpPage('已退款')">查看</el-button>
      </div>
    </div>
    <div class="page_div pa_div_sum wtj_color">
      <div>问题件</div>
      <div>{{ problematicDocument }}</div>
      <el-button type="primary" @click="jumpPage('问题件')">去处理</el-button>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request' // 就写这一行
import { obtainLabel } from './mainSTconfig';

export default {
  name: 'HomePage',
  props: {},
  data() {
    return {
      totalOrders: 0, // 总订单数
      unpaidOrder: 0, // 待支付订单数
      paidOrder: 0, // 已支付订单
      orderPayment: 0, // 支付中订单
      expiredOrder: 0, // 过期订单
      invalidOrder: 0, // 失效订单
      refundOrder: 0, // 退款订单
      problematicDocument: 0, // 问题件
    }
  },
  methods: {
    async obtainData() {
      try {
        // 自动带 Token，自动处理错误
        const res = await request.post('/ObtainOrderData', {});

        // 如果代码能走到这里，说明 HTTP 200 且 后端 success=true
        // this.$messageX.xiaoxiti("c", res.message);
        if (Object.keys(res.response.label).length > 0) {
          this.updateData(res.response);
        }
      } catch (err) {
        // 如果出错 (HTTP 401/500 或 后端 success=false)，会进这里
        console.log('失败:', err)
        if (err.response.data.message) {
          this.$messageX.xiaoxiti("e", err.response.data.message);
        } else {
          this.$messageX.xiaoxiti("e", err.message);
        }
      }
    },
    updateData(datas) {
      let labels = Object.values(datas.label);

      if (labels.includes(obtainLabel[0])) {
        let index_value = labels.indexOf(obtainLabel[0]);
        let keys_str = Object.keys(datas.label)[index_value];
        this.unpaidOrder = datas.data[keys_str].length; // 待支付订单数
      }

      if (labels.includes(obtainLabel[2])) {
        let index_value = labels.indexOf(obtainLabel[2]);
        let keys_str = Object.keys(datas.label)[index_value];
        this.paidOrder = datas.data[keys_str].length; // 待支付订单数
      }

      if (labels.includes(obtainLabel[1])) {
        let index_value = labels.indexOf(obtainLabel[1]);
        let keys_str = Object.keys(datas.label)[index_value];
        this.orderPayment = datas.data[keys_str].length; // 待支付订单数
      }

      if (labels.includes(obtainLabel[3])) {
        let index_value = labels.indexOf(obtainLabel[3]);
        let keys_str = Object.keys(datas.label)[index_value];
        this.expiredOrder = datas.data[keys_str].length; // 待支付订单数
      }

      if (labels.includes(obtainLabel[4])) {
        let index_value = labels.indexOf(obtainLabel[4]);
        let keys_str = Object.keys(datas.label)[index_value];
        this.invalidOrder = datas.data[keys_str].length; // 待支付订单数
      }

      if (labels.includes(obtainLabel[5])) {
        let index_value = labels.indexOf(obtainLabel[5]);
        let keys_str = Object.keys(datas.label)[index_value];
        this.refundOrder = datas.data[keys_str].length; // 待支付订单数
      }

      if (labels.includes(obtainLabel[6])) {
        let index_value = labels.indexOf(obtainLabel[6]);
        let keys_str = Object.keys(datas.label)[index_value];
        this.problematicDocument = datas.data[keys_str].length; // 待支付订单数
      }

      this.totalOrders = this.unpaidOrder + this.paidOrder + this.orderPayment + this.expiredOrder + this.invalidOrder + this.refundOrder + this.problematicDocument; // 总订单数
    },
    jumpPage(value) {
      this.$emit('jump', {
        "page": "Process",
        "types": value
      });
    }
  },
  mounted() {
    this.obtainData();
    this.$socket.on('background_data_update', () => {
      this.obtainData();
    });
  }
}
</script>

<style scoped>
.page-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-evenly;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  font-size: smaller;
  font-weight: 700;
}

.page_div {
  width: 100%;
  height: calc((100% / 5) - 30px);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  border-radius: 15px;
  background-color: rgb(145 212 241);
}

.page_z {
  display: flex;
  position: relative;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
  width: calc((100% / 2) - 20px);
  border-radius: 15px;
  background-color: blueviolet;
}

.label_left_top {
  position: absolute;
  top: 15px;
  left: 15px;
}

.label_left_bottom {
  position: absolute;
  left: 15px;
  bottom: 15px;
}

.label_right_top {
  position: absolute;
  top: 15px;
  right: 15px;
}

.backgrond_clear {
  background-color: rgba(255, 255, 255, 0);
}

.pa_div_sum {
  padding-right: 15px;
  padding-left: 15px;
}

.dzf_color {
  background-color: #E3E2DD;
}

.yzf_color {
  background-color: #E3D6B1;
}

.zfz_color {
  background-color: #4A67;
}

.gq_color {
  background-color: #C1A690;
}

.sx_color {
  background-color: #296;
}

.tk_color {
  background-color: #C07477;
}

.wtj_color {
  background-color: #F14752;
}
</style>